import apiClient from "../../../../helpers/apiClient";

const normalizeCashAmount = (amount) => parseFloat(Number(amount).toFixed(2));

export const fetchReservationById = async (reservationId) => {
    try {
        const { data } = await apiClient.get(`/api/reservation/${reservationId}`);
        if (data?.success && data?.data) return data.data;
    } catch {
        // fall through to past reservation
    }

    try {
        const { data } = await apiClient.get(`/api/past-reservation/${reservationId}`);
        if (data?.success && data?.data) return { ...data.data, flag: false };
    } catch {
        // not found
    }

    return null;
};

export const registerReservationCashPayment = async (
    reservationId,
    amount,
    reservationProcess = "scheduled",
) => {
    const normalizedAmount = normalizeCashAmount(amount);
    if (!normalizedAmount) return null;

    const { data } = await apiClient.post(`/api/reservation/cash-payment/${reservationId}`, {
        amount: normalizedAmount,
        paymentMethod: "cash",
        reservationProcess,
    });

    if (!data?.success) {
        throw new Error(data?.message || "Failed to register cash payment");
    }

    return data?.data || null;
};

export const createDepositPaymentCheckout = async ({
    reservationId,
    amount,
    customerEmail,
    successUrl,
    cancelUrl,
    metadata,
    companyId,
}) => {
    const { data } = await apiClient.post(
        "/api/payment-v2/create-deposit-payment-intent",
        {
            reservationId,
            amount,
            customerEmail,
            successUrl,
            cancelUrl,
            metadata,
        },
        companyId ? { headers: { "company-id": companyId } } : undefined,
    );

    if (!data?.success) {
        throw new Error(data?.message || "Could not create insurance payment session");
    }

    return data?.data;
};

export const createFinalSettlementCheckout = async ({
    reservationId,
    customerEmail,
    successUrl,
    cancelUrl,
    metadata,
    companyId,
}) => {
    const { data } = await apiClient.post(
        "/api/payment-v2/final-settlement-v2",
        {
            reservationId,
            customerEmail,
            successUrl,
            cancelUrl,
            metadata,
            companyId,
        },
        companyId ? { headers: { "company-id": companyId } } : undefined,
    );

    if (!data?.success) {
        throw new Error(data?.message || "Could not create final settlement payment session");
    }

    return data?.data;
};

export const sendReservationPaymentLink = async ({ reservationId, customerEmail, paymentUrl, companyId }) => {
    const { data } = await apiClient.post(
        "/api/payment-v2/send-payment-link",
        {
            reservationId,
            customerEmail: customerEmail.trim(),
            paymentUrl,
        },
        companyId ? { headers: { "company-id": companyId } } : undefined,
    );

    if (!data?.success) {
        throw new Error(data?.message || "Failed to send payment link");
    }

    return data?.data;
};

export const verifyStripePaymentReturn = async (reservationId) => fetchReservationById(reservationId);
